import Vue from 'vue'
import store from '@/store'

var CLOUDPODS_SCOPED_ERRORS = []

function formatComponentName (vm) {
  try {
    if (vm.$root === vm) return 'root'

    const name = vm._isVue
      ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
      : vm.name
    return (
      (name ? 'component <' + name + '>' : 'anonymous component') +
      (vm._isVue && vm.$options && vm.$options.__file
        ? ' at ' + (vm.$options && vm.$options.__file)
        : '')
    )
  } catch (error) {
    // 无需出错处理
  }
}

Vue.config.errorHandler = function (err, vm, info) {
  // 所有axios请求错误都在http.js中处理
  if (err && err.isAxiosError) {
    return
  }

  const error = { error: err }
  try {
    if (vm) {
      error.meta = {
        componentName: formatComponentName(vm),
        propsData: vm.$options && vm.$options.propsData,
        info: info,
      }
    }

    if (store.getters.dialogs && store.getters.dialogs['CloudpodsAssistantDialog-saas']) {
      if (CLOUDPODS_SCOPED_ERRORS.length > 5) {
        CLOUDPODS_SCOPED_ERRORS.splice(0, 1)
      }
      CLOUDPODS_SCOPED_ERRORS.push(error)
    } else {
      // reset or first load
      CLOUDPODS_SCOPED_ERRORS = []
      CLOUDPODS_SCOPED_ERRORS.push(error)
      store.dispatch('dialog/create', {
        name: 'CloudpodsAssistantDialog',
        id: 'CloudpodsAssistantDialog-saas',
        params: {
          errors: CLOUDPODS_SCOPED_ERRORS,
        },
      })
    }
  } catch (error) {
    // 无需出错处理
  }
}
